import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const irrigationApi = createApi({
    reducerPath: "core/irrigation",
    baseQuery: axiosBaseQuery,
    tagTypes: ["irrigationList"],
    endpoints: (builder) => ({
        irrigationFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['irrigationList'],
            query: (query = '') => ({
                url: "/core/irrigation" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        irrigationCreate: builder.mutation({
            invalidatesTags: ['irrigationList'],
            query: (data) => ({
                url: `/core/irrigation`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        irrigationUpdate: builder.mutation({
            invalidatesTags: ['irrigationList'],
            query: (data) => ({
                url: `/core/irrigation/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        irrigationDelete: builder.mutation({
            invalidatesTags: ['irrigationList'],
            query: (id) => ({ url: "/core/irrigation/" + id, method: "DELETE" })
        }),
    })
})

export const { useIrrigationFindAllQuery, useIrrigationCreateMutation, useIrrigationUpdateMutation, useIrrigationDeleteMutation } = irrigationApi;
export { irrigationApi };
